//FIXME: Leaving this here in case a better solution shows up in the following weeks
// const _getExternalComponentFocusableItems = (
//   childElement: Element,
//   focusableHTMLSelectors: string,
//   iteration = 0,
// ) => {
//   const resultingElements = [];
//   let root: Element | ShadowRoot | null = childElement.shadowRoot;

//   if (!root || !root.delegatesFocus) {
//     root = childElement.tagName.includes('-') ? childElement : null;
//   }

//   if (root) {
//     resultingElements.push(...root.querySelectorAll(focusableHTMLSelectors));

//     if (resultingElements.length === 0 && iteration < 2) {
//       const innerWebComponentsComponent = Array.from(childElement.children).filter(child =>
//         child.tagName.includes('-'),
//       );

//       innerWebComponentsComponent.forEach(component => {
//         resultingElements.push(
//           ..._getExternalComponentFocusableItems(component, focusableHTMLSelectors, ++iteration),
//         );
//       });
//     }
//   }

//   return resultingElements;
// };

export const deepSearchForFocusableSelectors = (childElement: Element, focusableTags: string[]) => {
  const focusableHTMLSelectors = focusableTags.map(tag => tag.toLowerCase()).join(', ');
  let resultingElements: Element[] = [];
  let hasExternal = false;

  if (focusableTags.includes(childElement.tagName)) {
    resultingElements = [childElement as Element];
  }

  resultingElements.push(...Array.from(childElement.querySelectorAll(focusableHTMLSelectors)));
  const externalWebComponents = Array.from(childElement.children).filter(child =>
    //dataset is not working with typescript for reasons.
    (child as HTMLElement).hasAttribute('data-name'),
  );
  if (externalWebComponents.length > 0) {
    hasExternal = true;
  }

  return { elements: resultingElements, hasExternal };
};
